import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Phone number validator for US phone numbers.
 * Accepts various formats: 1234567890, 123-456-7890, (123) 456-7890, etc.
 *
 * @returns Angular ValidatorFn
 *
 * @example
 * phone: ['', [phoneNumberValidator(), Validators.maxLength(15)]]
 */
export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // Allow null/undefined/empty - let Validators.required handle required validation
    if (!value) {
      return null;
    }

    // Trim whitespace
    const trimmedValue = typeof value === 'string' ? value.trim() : String(value);

    if (trimmedValue === '') {
      return null;
    }

    // Phone pattern: accepts 10-digit US phone numbers in various formats
    // Formats: 1234567890, 123-456-7890, 123.456.7890, (123) 456-7890, (123)456-7890
    const phonePattern = /^\s*[(]?(\d{3})[)]?[-. )]?(\d{3})[-. ]?(\d{4})\s*$/;

    if (!phonePattern.test(trimmedValue)) {
      return {
        phoneNumber: {
          message: 'Invalid phone number format. Must be 10 digits in the format 9999999999 or 999-999-9999'
        }
      };
    }

    return null;
  };
}
